import React, { useEffect, useState } from 'react';

const emptyUser = { email: '', password: '', username: '', role: 'student' };

function UserForm({ selected, onSave, onCancel }) {
  const [form, setForm] = useState(emptyUser);
  const update = (key, value) => setForm((current) => ({ ...current, [key]: value }));

  useEffect(() => {
    setForm(selected ? { ...selected, password: '' } : emptyUser);
  }, [selected]);

  const submit = async (event) => {
    event.preventDefault();
    const payload = { ...form };
    if (selected && !payload.password) delete payload.password;
    await onSave(payload);
    if (!selected) setForm(emptyUser);
  };

  return (
    <form className="admin-form" onSubmit={submit}>
      <div className="form-heading"><h2>{selected ? 'Edit user' : 'Add a user'}</h2><p>Students cannot create their own accounts.</p></div>
      <div className="form-grid">
        <label>Username<input required value={form.username || ''} onChange={(e) => update('username', e.target.value)} /></label>
        <label>Email<input type="email" required value={form.email || ''} onChange={(e) => update('email', e.target.value)} /></label>
        <label>Password<input type="password" required={!selected} value={form.password || ''} onChange={(e) => update('password', e.target.value)} placeholder={selected ? 'Leave blank to keep current' : ''} /></label>
        <label>Role<select value={form.role || 'student'} onChange={(e) => update('role', e.target.value)}><option value="student">Student</option><option value="admin">Admin</option></select></label>
      </div>
      <div className="form-actions">
        {selected && <button type="button" className="button ghost" onClick={onCancel}>Cancel</button>}
        <button className="button primary">{selected ? 'Save changes' : 'Create user'}</button>
      </div>
    </form>
  );
}

export default UserForm;